<script>
export default { inheritAttrs: false };
</script>

<script setup>
import { defineProps, ref, watch } from 'vue';

const props = defineProps({
	placeholder: {
		type: String,
		default: '',
	},
	disabled: {
		type: Boolean,
		default: false,
	},
	response: {
		type: String,
		required: false,
	},
});

const textValue = ref('');

watch(
	() => props.response,
	(text) => {
		textValue.value = text ?? '';
	},
	{ immediate: true },
);
</script>
<template>
	<div class="mt-4">
		<textarea
			v-if="props.disabled"
			class="w-full border border-neutral-200 rounded-lg p-3 text-sm text-neutral-700 bg-neutral-50 resize-none"
			:placeholder="props.placeholder"
			:value="props.response ?? ''"
			readonly
			rows="4"
		></textarea>
		<textarea
			v-else
			v-model="textValue"
			class="w-full border border-neutral-200 rounded-lg p-3 text-sm text-neutral-700"
			:placeholder="props.placeholder"
			rows="4"
		></textarea>
	</div>
</template>
